import { type PlatformType } from '@backend/lib/db/schema/platform'
import { WorkspaceHeaderSocialAccounts } from '../workspace-header/workspace-header-social-accounts'

interface Props {
  selectedPlatform: PlatformType
  onPlatformChange: (platform: PlatformType) => void
  compatibility: Record<PlatformType, { compatible: boolean }>
  activePlatforms: PlatformType[]
  onActivePlatformsChange: (platforms: PlatformType[]) => void
}

export const WorkspacePreviewToggle = ({
  selectedPlatform,
  onPlatformChange,
  compatibility,
  activePlatforms,
  onActivePlatformsChange,
}: Props) => {
  // Deliberately NOT a scroll container: any overflow-x-auto box also clips
  // vertical overflow, which cut the floating indicator pills (the X-to-remove
  // above, the info/warning pill below) and made the row micro-scrollable.
  // Five publishable platforms at ~40px + gaps always fit the modal's minimum
  // width, so the row just centers; `pt-2 pb-5` reserves breathing room for
  // the pills that hang past the buttons.
  return (
    <WorkspaceHeaderSocialAccounts
      selectedPlatform={selectedPlatform}
      onSelectedPlatformChange={onPlatformChange}
      activePlatforms={activePlatforms}
      onActivePlatformsChange={onActivePlatformsChange}
      compatibility={compatibility}
      className="justify-center gap-4 overflow-visible px-2 pb-5 pt-2"
      publishableOnly
    />
  )
}
